import { useEffect, useState } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { comparisonOperatorConfigs, Operator } from '@global/constants/comparisonOperators'
import { User } from '@global/types'
import { UserId } from './types'
import { t } from '@lingui/core/macro'

interface Props {
  filterIndex: number
  filterValue: User
  operator: Operator
  options: User[]
  userMap: Map<UserId, User>
  onChange: (idx: number) => (obj: { target: { value: User } }) => void
}

export const SelectSingleUser = ({
  filterIndex,
  filterValue,
  operator,
  options,
  userMap,
  onChange,
}: Props) => {
  const [value, setValue] = useState<User | null>(filterValue || null)
  const operatorConfig = comparisonOperatorConfigs[operator]
  const canHaveValue = Boolean(operatorConfig?.canHaveValueOperand())

  useEffect(() => {
    if (!canHaveValue) {
      setValue(null)
    }
  }, [canHaveValue])

  return (
    <FormControl disabled={!canHaveValue} fullWidth>
      <InputLabel id="value-select-label">{t`Value`}</InputLabel>
      <Select
        labelId="value-select-label"
        name="Value"
        value={value?.id ?? ''}
        onChange={e => {
          handleChange(e.target.value as UserId, filterIndex)
        }}
      >
        {options.map(({ id, name }) => (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )

  function handleChange(userId: UserId, index: number): void {
    const user = userMap.get(userId)

    if (!user) return

    setValue(user)
    onChange(index)({ target: { value: user } })
  }
}
